export default __webpack_public_path__ + "static/xpollinate-a12e3a774b660d835905cf1542c8299a.jpg";